module.exports = __webpack_public_path__ + "media/audio120.1c3c98aa.mp3";